import { render } from "./faqs-accordion.vue?vue&type=template&id=e4748b6e"
import script from "./faqs-accordion.vue?vue&type=script&lang=js"
export * from "./faqs-accordion.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__